(function scrollReveal() {
  const SELECTOR = '[data-scroll-reveal]';

  /**
   * @param {Element} element
   */
  function reveal(element) {
    element.classList.remove('is-hidden');
    element.classList.add('is-visible');
  }

  /**
   * @param {Element} element
   * @returns {boolean}
   */
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function init() {
    const elements = document.querySelectorAll(`${SELECTOR}:not(.is-visible)`);
    if (!elements.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(reveal);
      return;
    }

    elements.forEach((element) => {
      element.classList.add('is-hidden');
    });

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.1,
      }
    );

    elements.forEach((element) => {
      if (isInViewport(element)) {
        reveal(element);
        return;
      }

      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
